import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=5773093a&scoped=true"
import script from "./ViewResult.vue?vue&type=script&lang=js"
export * from "./ViewResult.vue?vue&type=script&lang=js"
import style0 from "./ViewResult.vue?vue&type=style&index=0&id=5773093a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773093a",
  null
  
)

export default component.exports